// Estado vacío consistente para listados
import React from "react";
import PropTypes from "prop-types";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

export default function EmptyState({ icon: Icon, title, subtitle, actionLabel, onAction }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 4, sm: 6 },
        textAlign: "center",
        borderRadius: 3,
        border: "1px dashed",
        borderColor: "grey.300",
        bgcolor: "background.paper",
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "16px",
          bgcolor: "rgba(245,158,11,0.12)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mb: 2.5,
        }}
      >
        {Icon && <Icon sx={{ fontSize: 32, color: "#D97706" }} />}
      </Box>
      <Typography variant="h5" fontWeight={700} mb={1}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body2"
          color="text.secondary"
          mb={onAction ? 3 : 0}
          maxWidth={420}
          mx="auto"
        >
          {subtitle}
        </Typography>
      )}
      {onAction && (
        <Button
          startIcon={<AddIcon />}
          onClick={onAction}
          variant="contained"
          sx={{ borderRadius: 2, px: 3.5, py: 1.2 }}
        >
          {actionLabel}
        </Button>
      )}
    </Paper>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
};
